import schemaDefaults from 'json-schema-defaults';
import hash from 'object-hash';
import React from 'react';

import StarsWidget from '@swf/components/StarsWidget/StarsWidget';
import type { StaticContext } from '@swf/core/types/StaticContext';
import { loadWidget } from '@swf/core/utils/widgets';
import schemata from '@swf/widgets/schema';

const { services, config } = schemaDefaults(schemata.FooterWidget);
const props = {
  type: 'FooterWidget' as const,
  meta: { name: 'Footer Widget' },
  services,
  config
};

export const id = hash(props);

const widgetProps = { ...props, id };

const EmbeddedFooter: React.FC<{ staticContext?: StaticContext }> = ({ staticContext = {} }) => {
  staticContext.prefetch = ({ dispatch }) => loadWidget(widgetProps, { dispatch });
  return <StarsWidget {...widgetProps} />;
};

export default EmbeddedFooter;
